import { useState } from "react";
import "./Homepage.css";

export default function Homepage() {
    const [isClicked , setIsClicked] = useState(false);

    const handleClick =()=>{
        setIsClicked(!isClicked);
    }
    return (
        <div className="homepage" >
            <div className="image1" >
                <img src="https://cdn.pixabay.com/photo/2022/02/12/21/22/toast-7009956_640.jpg" alt="a change" className="img1"/>
            </div>

            <div className="image2">
                <img src="https://cdn.pixabay.com/photo/2017/02/16/11/10/porridge-2071158_640.jpg" alt="a change" className="img2"/>
            </div>

            <div className="image3">
                <img src="https://cdn.pixabay.com/photo/2015/04/19/14/46/smoothie-729922_640.jpg" alt="a change" className="img3"/> 
            </div>
        </div>
    )
}